import { TYPE_COLLECTION } from './input-types';

export const id = 'insurance';
export const apiKey = 'InsuranceProviderId';
export const type = TYPE_COLLECTION;

export const insurance = {
  id,
  apiKey,
  type,
};
